import React, { useEffect } from 'react';
import HelloSign from 'hellosign-embedded';

interface PropTypes {
  secureId: string;
  link: string;
  clientId: string;
}

export default function Page(props: PropTypes) {
  useEffect(() => {
    const client = new HelloSign();

    client.open(props.link, {
      clientId: props.clientId,
      skipDomainVerification: true,
      container: document.body,
      allowCancel: false,
    });

    client.on('sign', () => {
      window.location.href = `/applicant_tracking/signing_links/signed?secure_id=${props.secureId}`;
    });

    client.on('decline', () => {
      window.location.href = `/applicant_tracking/signing_links/declined?secure_id=${props.secureId}`;
    });
  }, []);

  return <div />;
}
